import { Button, Divider, PageHeader, Popover, Table, Tooltip } from "antd";
import { PageTitleComp, RightLayoutContainer, TableLayoutData } from "../../styledElements";
import Iconmoon from "../../../Components/IconsFiles/icon";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import { useEffect, useState } from "react";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import DefaultProfilePicture from "../../../Assets/Images/default-pic.png";
import { Link } from "react-router-dom";
import { Styled } from "../../pageStyled";
import { useNavigate } from "react-router-dom";
import { deleteRole, getAllRoles } from "../../../Services/notifications&rolesServices";
import axios from "axios";
import { getImageURL } from "../../../Services/deckleMatchServices";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";

const Roles = () =>{
  const navigate=useNavigate();
  const [loading,setLoading] =useState(false);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [allRoles,setAllRoles] = useState();
  const [modalVisible,setModalVisible] = useState(false);
  const [selectedRecord,setSelectedRecord] = useState();
  const [actionToaster,setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [visibleToaster,setVisibleToaster] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem('user-details'));
  const source = axios.CancelToken.source();
  
  const getformattedUsers = async (users) => {
    try{
      const formatedUsers = await Promise.all(users.map(async (user)=>{
        return {
          name: user.name,
          email: user.email,
          photo: user.profile_picture && await getImageURL({
            bucket_key:user.profile_picture,
              operation:"download",
            }),
          }
        }))
        return formatedUsers;
      }
      catch(e)
      {
        console.log(e);
      }
    }

    const getRoles = async () => {
      try{
        const response = await getAllRoles(source);
        if(response.length)
        {
          const rolesData = await Promise.all(response.map(async(role)=>{
            return {
              role: role?.name,
              roles: role.roles,
              access_count: role.access_count,
              assigned_to: await getformattedUsers(role.users),
              created_by: role.created_by,
            }
          }))
          setAllRoles([...rolesData]);
        }
        else
          {
            setEmptyStateLabel("noData");
          }
        setLoading(false);
      }
      catch(e)
      {
        setEmptyStateLabel("connectionApiError");
        setLoading(false);
        console.log(e);
      }
    }
    
    const refresh = () => {
      setLoading(true);
      getRoles();
    }

    const showToaster = () => {
      setVisibleToaster(true);
      setTimeout(()=>setVisibleToaster(false),1500);
    }
      
    const handleDeleteRole = async() => {
      try{
        const deletedRole = await deleteRole(selectedRecord.role);
        setModalVisible(false);
        refresh();
        setActionToaster({
          error:deletedRole.error,
          msg:deletedRole.msg,
        })
        showToaster();
      }
      catch(e)
      {
        console.log(e);
        setModalVisible(false);
        setActionToaster({
          error:e?.response?.data.error,
          msg:e?.response?.data.msg,
        })
        showToaster()
      }
    }

    const checkDeletable = (record) => {
      let predefinedRoles = ["ADMIN","SALES_COORDINATOR","DECKLE_PLANNER","PLANT_OPERATOR","SUPER_ADMIN"];
      if(userDetails.role_type == "ADMIN" && userDetails.email == record.created_by && !predefinedRoles.includes(record.role))
        return false;
      else
        return true;
    }

    const checkEditable = (record) => {
      if(["ADMIN","SUPER_ADMIN"].includes(userDetails.role_type) && !["ADMIN","SUPER_ADMIN"].includes(record?.role))
        return false;
      else
        return true;
    }

    const columnsHead = [
      {
        title: "Role",
        dataIndex: "role",
        sorter: (a,b) => a.role.localeCompare(b.role),
        render: (text) => <span>{text.replaceAll("_"," ")}</span>
      },
      {
        title: "Access",
        dataIndex: "access_count",
        render: (text,record) => <span>Has access to {record.access_count} modules.</span>
      },
      {
        title: "Assigned to",
        dataIndex: "assigned_to",
        render: (text,record) => {
          const assignedUsers = <div className="ant-drawer-title" style={{overflowY:"scroll",maxHeight:"300px",minWidth:"200px"}}>{record?.assigned_to?.map((user) => (
            <div className="userDataCell" style={{paddingBottom:"5px"}}>
                  <div className="userPimage">
                    <img src={(user?.photo)?user.photo:DefaultProfilePicture} alt="Profile Picture"/>
                  </div>
                  <div className="userBio">
                    <label>{user?.name}</label>
                    <p>{user?.email}</p>
                  </div>
                </div>
              ))}
              </div>
              return (<div style={{display:"flex", alignItems:"center", position:"relative"}}>
                <span>{record?.assigned_to?.length} users</span>
                <Popover content={assignedUsers} title="Assigned Users" placement="bottom" trigger="hover" getPopupContainer={triggerNode => triggerNode.parentNode}>
                  <Button className="textTypeBtn">
                    View
                  </Button>
                </Popover>
              </div>
            )
          }
        },    
        {
          title: "Created by",
          dataIndex: "created_by",
        },
        {
          title: "Actions",
          align: "center",
          render: (_,record) => (
            <div className="actionBtn">
              <Styled>
                <Tooltip
                  title="Edit Role"
                  placement="bottomRight"
                  className="edit-tooltip"
                  >
                  <Button disabled={checkEditable(record)}>
                    <Link to={{
                      pathname:"/organization-setting/roles-and-permissions/edit-role",
                      search:`?name=${record?.role}`
                    }}>
                      <Iconmoon icon="edit" size={16} color="#A19F9D"/>
                    </Link>
                  </Button>
                </Tooltip>
              </Styled>
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title="View Role"
                  className="edit-tooltip"
                  >
                  <Button>
                    <Link to={{
                      pathname:"/organization-setting/roles-and-permissions/view-role",
                      search:`?name=${record?.role}`
                    }}>
                      <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                    </Link>
                  </Button>
                </Tooltip>
              </Styled>
              <Styled>
                <Tooltip
                  title="Delete Role"
                  placement="bottomRight"
                  className="edit-tooltip"
                  >
                  <Button
                    disabled={checkDeletable(record)}
                    onClick={()=>{
                      setModalVisible(true);
                      setSelectedRecord(record)
                    }}
                  >
                    <Iconmoon icon="delete" size={16} color="#A19F9D"/>
                  </Button>
                </Tooltip>
              </Styled>
            </div>
          )
        }
      ]
    
    useEffect(()=>{
      setLoading(true);
      getRoles();
      return ()=>source.cancel();
    },[]);
    
    useEffect(() => {
      let propsData = {};
      if(emptyStateLabel === "noData"){
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "No records in this list";
        propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
      } else if(emptyStateLabel === "search"){
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "No records found";
        propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
      } else if(emptyStateLabel === "filter"){
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "No records found";
        propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
      } else {
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "Something went wrong";
        propsData["subHeading"] = "Check your internet connection or try reloading the page.";
      }
      setEmptyStatePropsData(propsData);
    },[emptyStateLabel]);

    return (
      <RightLayoutContainer>
        <PageTitleComp>
          <PageHeader
            ghost={false}
            title="Roles and Permissions"
            extra={[
              <Button
                key="1"
                className="themeBtn"
                onClick={()=>navigate("./create-role")}
                // disabled={!userDetails.roles.user_management.edit}
              >
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Add New Role
              </Button>,
            ]}
          ></PageHeader>
        </PageTitleComp>
        <TableLayoutData style={{marginTop:"30px"}}>
          <div className="tableDataFormat">
            {loading ? (
              <TableShimmer header={columnsHead} />
            ) : allRoles?.length ? (
              <Table
                columns={columnsHead}
                dataSource={allRoles}
                // onChange={onChange}
                // pagination={{
                //   total: allUsers.length,
                //   showTitle: false,
                //   showTotal: (total, range) =>
                //     `Showing ${range[0]}-${range[1]} of ${total} results`,
                // }}
              />
            ) : (
              <EmptyState
                img={
                  emptyStateLabel === "noData" || emptyStateLabel === "filter"
                    ? emptyState_NoData
                    : emptyStateLabel === "search"
                    ? emptyState_Search
                    : emptyState_ConnectionAPIError
                }
                heading={emptyStatePropsData?.heading}
                subHeading={emptyStatePropsData?.subHeading}
                label={emptyStatePropsData?.label}
                refresh={refresh}
              />
            )}
          </div>
        </TableLayoutData>
        <ConfirmationModal
          visible={modalVisible}
          icon={warning}
          confirmAction={()=>handleDeleteRole()}
          cancelAction={()=>setModalVisible(false)}
        >
          <span>Are you sure?</span>
          <p>
            Once deleted the role cannot be recovered. Do you want to continue?
          </p>
        </ConfirmationModal>
        {visibleToaster && !actionToaster.error && (
          <AlertContainer
            color="green toaster"
            icon={alertGreen}
            msg={actionToaster.msg}
          />
        )}
        {visibleToaster && actionToaster.error && (
          <AlertContainer
            color="red toaster"
            icon={alertRed}
            msg={actionToaster.msg}
          />
        )}
      </RightLayoutContainer>
    );
}

export default Roles;